import React, { useRef, useState } from 'react';

const ExpertsSection = () => {
  const videoRef = useRef(null);
  const [started, setStarted] = useState(false);

  const handlePlay = () => {
    const video = videoRef.current;
    if (video) {
      video.play();
      setStarted(true);
    }
  };

  return (
    <section id="especialistas" className="mgs-experts">
      <div className="mgs-experts__inner">
        <h2 className="mgs-experts__title">
          Especialistas de todo Brasil{' '}
          <span className="mgs-experts__title-gold">recomendam</span> o{' '}
          <span className="mgs-experts__title-gold">Magrisim</span>
        </h2>

        <div className="mgs-experts__video">
          <video
            ref={videoRef}
            className="mgs-experts__media"
            controls={started}
            playsInline
            preload="metadata"
          >
            {/* Versão web (H.264) — compatível com todos os navegadores */}
            <source src={`${process.env.PUBLIC_URL}/especialista_web.mp4`} type="video/mp4" />
            Seu navegador não suporta a reprodução deste vídeo.
          </video>

          {!started && (
            <button
              type="button"
              className="mgs-experts__overlay"
              onClick={handlePlay}
              aria-label="Reproduzir vídeo"
            >
              <span className="mgs-experts__play">
                <i className="fas fa-play"></i>
              </span>
            </button>
          )}
        </div>
      </div>
    </section>
  );
};

export default ExpertsSection;
